import { Text } from '@ltvco/refresh-lib/theme';
import { useLocation, useParams } from 'react-router-dom';

import {
  COURT_CASES_V2_ROUTES,
  LEGAL_INTELLIGENCE_ROUTES,
  parseLegalIntelSection,
  withLegalIntelSection,
} from '../../../constants';
import {
  useOralArgumentDetails,
  CourtCaseDisclaimer,
  InlineLoading,
  ErrorStateContainer,
} from '../../shared';
import { LegalSearchBreadcrumbs } from '../../shared/LegalSearchBreadcrumbs';

import {
  DetailsPageContainer,
  DetailsContentSection,
  DetailsTranscriptWrap,
} from './components';
import { OralArgumentAudio } from './OralArgumentAudio';
import { OralArgumentDetailsHeader } from './OralArgumentDetailsHeader';
import { OralArgumentTranscript } from './OralArgumentTranscript';

export const OralArgumentDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const result = useOralArgumentDetails(id);
  const { oralArgumentQuery, isLoading } = result;

  const {
    data: oralArgumentData,
    isError: isOralArgumentError,
    error: oralArgumentError,
  } = oralArgumentQuery;

  if (isLoading) {
    return <InlineLoading />;
  }

  if (isOralArgumentError || !oralArgumentData) {
    const errorMessage =
      oralArgumentError instanceof Error
        ? oralArgumentError.message
        : 'Oral argument not found';
    return (
      <ErrorStateContainer>
        <Text color="error">Error: {errorMessage}</Text>
      </ErrorStateContainer>
    );
  }

  const oralTitle =
    oralArgumentData.caseName?.trim() ||
    oralArgumentData.docketNumber?.trim() ||
    (id ? `Oral argument ${id}` : 'Oral argument');

  const section = parseLegalIntelSection(location.search, location.pathname);

  return (
    <DetailsPageContainer>
      <LegalSearchBreadcrumbs
        segments={[
          { label: 'Legal Intelligence', to: LEGAL_INTELLIGENCE_ROUTES.BASE },
          {
            label: 'Oral Arguments',
            to: withLegalIntelSection(
              COURT_CASES_V2_ROUTES.ORAL_ARGUMENTS,
              section
            ),
          },
          { label: oralTitle },
        ]}
      />
      <OralArgumentDetailsHeader oralArgument={oralArgumentData} />

      <DetailsContentSection>
        <OralArgumentAudio
          downloadUrl={oralArgumentData.download_url || null}
        />
        <DetailsTranscriptWrap>
          <OralArgumentTranscript
            transcript={oralArgumentData.stt_transcript}
          />
        </DetailsTranscriptWrap>
      </DetailsContentSection>

      <CourtCaseDisclaimer />
    </DetailsPageContainer>
  );
};
